import React, { useMemo } from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import SEO from '../components/seo';

import '../styles/venue-hire.scss';
import VenueBox from '../components/venue-box';
import ImageCarousel from '../components/image-carousel';
import BodyText from '../components/woolwich-portable-text';

export const query = graphql`
  query VenueHirePageQuery {
    site: sanitySiteSettings(_id: {regex: "/(drafts.|)siteSettings/"}) {
      title
      description
    },
     vh: sanityVenueHire {
      title
      intro
      _rawContent
      enquireNowEmail
      imageSlider {
        asset {
          fluid(maxWidth: 1200) {
            ...GatsbySanityImageFluid
          }
          url
        }
        attribution
      }    
      video,
      venues {
        id
        people
        sqft
        dimensions
        title
        imageSlider {
          asset {
            fluid(maxWidth: 1200) {
            ...GatsbySanityImageFluid
            }
          }
          attribution
        }  
        suitableForTags {
          title
        }
        facilitiesTags {
          title
        }
      }  
    }
  }
`;

const VenueHire = ({ location, data }) => {

  const venues = useMemo(() => {
    return data.vh.venues.map((venue, idx) => {
      return venue;
    });
  }, [data.vh.venues]);

  return (
    <Layout pageTitle={data.vh.title} pageTitleColour={'regal-purple'} >
      <SEO 
        location={location} 
        title={`${data.vh.title} | ${data.site.title}`} 
        description={data.site.description}
        imageAsset={data.vh.imageSlider[0].asset}
      />

      {/* Carousel */}
      <div className='image-carousel-harness'>
        <ImageCarousel images={data.vh.imageSlider} video={data.vh.video}/>
      </div>

      <div className='strip'>
        <div className='strip__middle pad-sides'>

          <div className='venue-hire-intro limit-width'>
            <div className='venue-hire-intro__title'>{data.vh.intro}</div>
            <BodyText
              blocks={data.vh._rawContent}
            />
          </div>
          <a className='button venue__button' href={`mailto:${data.vh.enquireNowEmail}`}>Enquire now&nbsp;→</a>

        </div>
      </div>

      <div className='strip'>
        <div className='strip__middle pad-sides'>

          <div className='venue-box-list'>
            {
              venues.map((venue, idx) => <VenueBox data={venue} key={idx}/>)
            }
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default VenueHire;

